import * as React from "react";
import { QNProps } from "@ezbuy/smartimagesrc/lib/ImageSrcHandlers/Handler";
import { ProductExtend, ScoreOption, TProductElement } from "../../../../services/product";
import { ModuleLayoutStyle } from "../../../../services/playground";

import SingleCard from "./SingleCard";
import DoubleCard from "./DoubleCard";
import TripleCard from "./TripleCard";

interface TProductElementEx extends TProductElement {
	pricenum?: string;
	originpricenum?: string;
}
export interface ProductCardProps {
	index: number;
	columnNum: number;
	productElement: TProductElementEx;
	isRollable: boolean;
	isWithViewMore?: boolean;
	stylesForCard?: React.CSSProperties;
	layoutStyle: ModuleLayoutStyle;
	placeholderBg: string;
	notUseQnparams?: boolean;
	onClick?: () => void;
	qnParams?: QNProps;
	isInApp: boolean;
	collectOptions?: ScoreOption;
	displayInfo?: ProductExtend;
	poolId?: string;
}

export default function MProductsCard(props: ProductCardProps) {
	let { columnNum } = props;
	if (![1, 2, 3].includes(columnNum)) {
		columnNum = 2;
	}
	const nextProps = transformQnparams(props);
	let ProductSkeleton;
	if (columnNum === 1) {
		ProductSkeleton = SingleCard;
	} else if (columnNum === 3) {
		ProductSkeleton = TripleCard;
	} else {
		ProductSkeleton = DoubleCard;
	}

	return <ProductSkeleton {...nextProps} />;
}

function transformQnparams(props: ProductCardProps) {
	let qnParams = {};
	if (!props.notUseQnparams) {
		qnParams = {
			w: 300,
		};
	}
	return {
		...props,
		qnParams,
	};
}
